// ** Reducers Imports

import authentication from "./authentication";
import candidate from "./candidate";
import jobPosts from "./jobPosts";
import employee from "./employee";
import attendance from "./attendance";
import leave from "./leave";
import institute from "./institute";
import inventory from "./inventory";

const rootReducer = {
  authentication,
  candidate,
  jobPosts,
  inventory,
  employee,
  attendance,
  leave,
  institute,
};

export default rootReducer;
